/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Tracking_Empty_TitleInputs */

const en_case_payment_tracking_empty_title = /** @type {(inputs: Case_Payment_Tracking_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments to track`)
};

const pt_br2_case_payment_tracking_empty_title = /** @type {(inputs: Case_Payment_Tracking_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum pagamento para acompanhar`)
};

/**
* | output |
* | --- |
* | "No payments to track" |
*
* @param {Case_Payment_Tracking_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_tracking_empty_title = /** @type {((inputs?: Case_Payment_Tracking_Empty_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Tracking_Empty_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_tracking_empty_title(inputs)
	return pt_br2_case_payment_tracking_empty_title(inputs)
});